export function usePriceLegalInfoTooltip(triggers = ['hover', 'click']) {
  const trPrefix = 'www.components.hitbox.Price.'

  const { t } = useI18n()

  return computed(() => ({
    content: [
      `<b>${t(`${trPrefix}dependentPrice`)}</b>`,
      t(`${trPrefix}priceAfterInput`),
      `<b>${t(`${trPrefix}addCosts`)}</b>`,
      t(`${trPrefix}addCostsLong`),
    ].join('<br/>'),
    html: true,
    triggers,
  }))
}
